<template>
  <tr-dialog
    ref="modal"
    name="tfa-activation-dialog"
    :on-save="() => { }"
    :on-close="close"
    save-button-label="Ativar"
    title="Ativar autenticação em 2 fatores"
    :has-its-own-buttons="true"
  >
    <tr-form
      ref="form"
      :on-valid-submit="onSubmit"
    >
      <div>
        <tr-typography variant="h5">
          Para ativar, use seu aplicativo de autenticação para ler o QR-Code, em seguida, insira o
          código gerado abaixo.
        </tr-typography>
        <div class="text-center vertical-offset2">
          <img
            :src="props.qrCodeSrc"
            alt="QR-Code"
          >
        </div>
        <div class="row center-h-and-v vertical-offset2">
          <tr-text-field
            v-model="code"
            autofocus="true"
            label="Digite o código gerado"
            required="true"
            name="code"
            no-margin="true"
            :exact-length="6"
            error-message="Código obrigatório e deve conter exatamente 6 números"
          />
        </div>
      </div>
      <tr-dialog-buttons-container>
        <bg-button
          type="button"
          class="pull-left"
          variant="outline"
          @click.prevent="cancel()"
        >
          Cancelar
        </bg-button>
        <bg-button
          size="md"
          class="pull-right"
          type="submit"
        >
          Ativar
        </bg-button>
      </tr-dialog-buttons-container>
    </tr-form>
  </tr-dialog>
</template>

<script setup>
import { ref } from 'vue';
import { BgButton } from '@transfeeradev/bridge';
import { getMessage } from '@/commons/services/error';
import { useToaster } from '@/commons/composables/useToaster';
import { enableTfa } from '@/commons/services/tfa';

const props = defineProps({
  qrCodeSrc: String
});

const emit = defineEmits(['cancel', 'activate', 'error']);

const toaster = useToaster();

const modal = ref();
const code = ref();

const open = () => {
  modal.value.open();
};

const close = () => {
  modal.value.close();
};

const cancel = () => {
  emit('cancel');
  close();
};

const onSubmit = async () => {
  try {
    await enableTfa(code.value);
    emit('activate');
    toaster.success('Autenticação ativada com sucesso!');
  } catch (e) {
    emit('error', e);
    toaster.error(getMessage(e));
  }
};

defineExpose({
  open,
  close
});
</script>
